import { Component, Input, ElementRef } from '@angular/core';

import { RippleDirectiveBase } from '../button/directives/ripple.directive';

@Component({
  selector: '[uex-dropdown-item], uex-dropdown-item',
  templateUrl: './item.component.html',
  host: {
    class: 'uex-dropdown-item dropdown-item with-ripple',
    '[class.is-active]': 'active',
    '[class.disabled]': 'disabled'
  }
})
export class DropdownItemComponent extends RippleDirectiveBase {
  @Input('alignItems') public alignItems = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  @Input() active: boolean;
  @Input() disabled: boolean;

  constructor(
    public elementRef: ElementRef
  ) {
    super(elementRef)
  }
}
